export default {
  methods: {
    // because if content loaded vie v-html that has links
    // router will not kick in, and app state is lost and app reloads
    catchHtmlClick(e) {
      const href = e.srcElement.href;
      if (href && href.indexOf(window.location.origin) === 0) {
        e.preventDefault();
        const path = href.substr(window.location.origin.length);
        this.$router.push({ path });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/helpers/catchHtmlClickMixin.js